import { useNavigate, useParams } from 'react-router-dom'
import { sendMessageToApp } from 'services/connectToApp'
import { themeColors } from 'theme'

import { CardCustomResult } from 'components/CardCustomResult'
import { CardBody, CardContainer } from 'components/CustomCard'
import { ChevronRightIcon } from 'components/SVGS'

type PaymentResultParamsProps = {
  result: string
  plate: string
  appointment: 'yes' | 'no'
  renewAutomatic: 'yes' | 'no'
  isOnlyRenew: 'yes' | 'no'
}

export const PaymentResult = () => {
  const navigate = useNavigate()
  const { isOnlyRenew, result, appointment, renewAutomatic } = useParams<PaymentResultParamsProps>()

  const { icon: { secondaryIconColor } } = themeColors

  const title = isOnlyRenew === 'yes' && result?.toLowerCase() === 'ok'
    ? 'Renovación automática activada'
    : result?.toLowerCase() === 'ok'
      ? '¡Pago recibido con éxito!' : '¡OOPS! No se pudo procesar tu pago'

  const message = isOnlyRenew === 'yes' && result?.toLowerCase() === 'ok'
    ? 'Hemos dejado activa la renovación automática para tu próxima fecha de caducidad'
    : result?.toLowerCase() !== 'ok'
      ? 'Por favor, inténtalo nuevamente' : appointment === 'yes'
        ? 'A continuación deberás agendar la instalación del dispositivo WiCar'
        : 'Desde ya podrás seguir usando todos los servicios premium que WiCar ofrece para ti'

  const message2 = isOnlyRenew === 'no' && result?.toLowerCase() === 'ok' && renewAutomatic === 'yes'
    ? `${message}. Además dejamos activa la renovación automática de tu suscripción`
    : message

  const handleSubmit = (appointment: boolean) => {
    const response = result?.toLowerCase()
    const redirectApp = response === 'ok' ? '/home' : '/vehicles'

    sendMessageToApp({ route:redirectApp })
    appointment
      ? navigate('/appointment')
      : navigate('/')
  }

  return (
    <CardContainer>
      <CardBody>
        {result && <CardCustomResult
          headerTitle={title}
          text={message2}
          type={result?.toLowerCase() === 'ok' ? 'success' : 'error'}
          primaryButtonText={result?.toLowerCase() !== 'ok'
            ? 'Entendido' : appointment === 'yes' && isOnlyRenew === 'no'
              ? 'Ir a Agendar' : 'Entendido'}
          {...result?.toLowerCase() === 'ok' && appointment === 'yes' && isOnlyRenew === 'no'
          && { primaryButtonProps: { rightIcon: <ChevronRightIcon fill={secondaryIconColor} /> } }}
          onSubmit={() =>
            handleSubmit(result?.toLowerCase() === 'ok' && appointment === 'yes' && isOnlyRenew === 'no')
          } />}
      </CardBody>
    </CardContainer>
  )
}
